import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Routes as ReactRouterRoutes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "api";

import { AVAILABLE_LOCALES, DEFAULT_LOCALE } from "./constants/locales";
import Layout from "./components/layout/Layout";
import { BusinessPage, CategoryBusinessesPage } from "./features/business/pages";
import Home from "./pages/home/Home";
import Routes from "./constants/routes";

import "./i18n/i18n";

const App = () => {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    if (!AVAILABLE_LOCALES.includes(i18n.language)) {
      i18n.changeLanguage(DEFAULT_LOCALE);
    }
  }, [i18n]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ReactRouterRoutes>
          <Route path={Routes.home} element={<Layout />}>
            <Route index element={<Home />} />
            <Route path={Routes.categoryBusinesses} element={<CategoryBusinessesPage />} />
            <Route path={Routes.business} element={<BusinessPage />} />
          </Route>
        </ReactRouterRoutes>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
